export default __webpack_public_path__ + "static/media/gift-2.f2f3380d.svg";